{
  "chart": {
    "header": "Ramverk"
  },
  "filter": {
    "placeholder": "Alla Dokument"
  }
}
